import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

export default ({
  periodName,
  entities,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  columnDefs,
  connectionName,
}) => {
  const sheetData = [{
    name: 'Trial Balance Out of Balance Threshold',
    type: SheetExportTypes.GRID,
    columnDefinitions: [
      ...columnDefs,
    ],
    data: entities,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
  }];

  return xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Trial_Balance_Out_of_Balance_Threshold_${periodName}_${connectionName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
